<template>
  <main :class="pageData ? '' : 'loading'">
    <carousel :slides="carousel"></carousel>
    <how-to-help></how-to-help>
    <our-story></our-story>
    <events :events="events"></events>
    <our-team></our-team>
    <breakdown :backpacks="backpacks" :countries="countries"></breakdown>
    <ways-you-can-help></ways-you-can-help>
    <donate></donate>
    <media-inquiries></media-inquiries>
    <contact-us></contact-us>
  </main>
</template>

<script>
import Carousel from './Home/Carousel'
import HowToHelp from './Home/HowToHelp'
import OurStory from './Home/OurStory'
import Events from './Home/Events'
import OurTeam from './Home/OurTeam'
import Breakdown from './Home/Breakdown'
import WaysYouCanHelp from './Home/WaysYouCanHelp'
import Donate from './Home/Donate'
import MediaInquiries from './Home/MediaInquiries'
import ContactUs from './Home/ContactUs'

export default {
  name: 'home',
  data () {
    return {
      pageData: null,
      slug: 'home'
    }
  },
  components: {
    Carousel,
    HowToHelp,
    OurStory,
    Events,
    OurTeam,
    Breakdown,
    WaysYouCanHelp,
    Donate,
    MediaInquiries,
    ContactUs
  },
  mounted () {
    this.getPageData()
  },
  methods: {
    getPageData () {
      const vm = this
      vm.$http.get('/pages?slug=' + this.slug)
      .then((response) => {
        vm.pageData = response.data[0]
      })
    }
  },
  computed: {
    acf () {
      if (this.pageData && this.pageData.acf) {
        return this.pageData.acf
      }
    },
    backpacks () {
      if (this.acf && this.acf.backpacks_given) {
        return this.pageData.acf.backpacks_given
      }
    },
    countries () {
      if (this.acf && this.acf.number_of_countries) {
        return this.pageData.acf.number_of_countries
      }
    },
    carousel () {
      if (this.acf && this.acf.homepage_carousel) {
        return this.pageData.acf.homepage_carousel
      }
    },
    events () {
      if (this.acf && this.acf.events) {
        return this.pageData.acf.events
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?3e8072dd